import React from 'react'
import { Button, Typography } from '@mui/material'
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  gridFilteredSortedRowEntriesSelector,
  useGridApiContext,
} from '@mui/x-data-grid'
import { RiFileExcel2Line } from 'react-icons/ri'
import * as XLSX from 'xlsx'

const ExcelExportToolbar = ({ reportName = 'Rapor', columns = [], showExtra }) => {
  const apiRef = useGridApiContext()

  const handleExcelExport = () => {
    // Filtrelenmiş ve sıralanmış satırları al
    const filteredRows = gridFilteredSortedRowEntriesSelector(apiRef)

    // disableExport: true olan ve dahili kolonları dışla
    const exportColumns = columns.filter(
      (col) => !col.disableExport && col.field !== '__check__' && col.field !== '__detail_panel_toggle__'
    )

    // Başlık satırı
    const headers = exportColumns.map((col) => col.headerName || col.field)

    // Veri satırları — tip dönüşümleriyle
    const rows = filteredRows.map(({ model }) =>
      exportColumns.map((col) => {
        // valueGetter varsa onu kullan, yoksa direkt model[col.field]
        let value = col.valueGetter
          ? col.valueGetter({ row: model })
          : model[col.field]

        if (value === undefined || value === null || value === '') return ''

        // Sayı kontrolü
        if (typeof value === 'number') return value

        // Sayıya dönüştürülebilir string kontrolü (telefon hariç)
        if (
          typeof value === 'string' &&
          col.field !== 'phone' &&
          !isNaN(Number(value)) &&
          value.trim() !== ''
        ) {
          return Number(value)
        }

        // Tarih kontrolü (DD-MM-YYYY HH:mm formatı)
        if (typeof value === 'string' && /^\d{2}-\d{2}-\d{4}/.test(value)) {
          const [datePart, timePart] = value.split(' ')
          const [day, month, year] = datePart.split('-')
          const dateStr = `${year}-${month}-${day}${timePart ? 'T' + timePart : ''}`
          const parsed = new Date(dateStr)
          if (!isNaN(parsed.getTime())) return parsed
        }

        return value
      })
    )

    // Çalışma sayfası oluştur
    const worksheetData = [headers, ...rows]
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)

    // Sütun genişliklerini otomatik ayarla
    worksheet['!cols'] = exportColumns.map((col, colIndex) => ({
      wch: Math.min(
        50,
        Math.max(
          col.headerName?.length || 10,
          ...rows.map((row) => String(row[colIndex] ?? '').length)
        )
      ),
    }))

    // Tarih hücrelerini Excel tarih formatında işaretle
    const range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1')
    for (let R = 1; R <= range.e.r; R++) {
      exportColumns.forEach((col, C) => {
        if (typeof rows[R - 1]?.[C] === 'object' && rows[R - 1]?.[C] instanceof Date) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C })
          if (worksheet[cellAddress]) {
            worksheet[cellAddress].z = 'dd/mm/yyyy hh:mm'
          }
        }
      })
    }

    // Çalışma kitabı oluştur ve dosyayı indir
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, reportName.slice(0, 31))

    const today = new Date().toISOString().split('T')[0]
    const fileName = `${reportName}_${today}.xlsx`

    XLSX.writeFile(workbook, fileName)
  }

  return (
    <GridToolbarContainer sx={{ alignItems: 'center', flexWrap: 'wrap', gap: 0.5 }}>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <Typography variant="caption" sx={{ ml: 1, color: 'text.secondary' }} title="Klavye kısayolu">
        {showExtra ? '✓' : ''}
      </Typography>
      <Button
        size="small"
        startIcon={<RiFileExcel2Line size={18} />}
        onClick={handleExcelExport}
        sx={{ color: '#217346', fontWeight: 600, ml: 0.5 }}
      >
        EXCELE İNDİR
      </Button>
    </GridToolbarContainer>
  )
}

export default ExcelExportToolbar
